var _defs, _g, _circle, _rect, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 49.02,
    y1: 8.75,
    x2: 49.02,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.84,
    y1: 8.75,
    x2: 37.84,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.66,
    y1: 8.75,
    x2: 26.66,
    y2: 14.52
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.18,
    cy: 27.16,
    r: 3.47
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.01,
    y: 19.25,
    width: 36.98,
    height: 36.98,
    rx: 5,
    ry: 5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.91,
    y1: 26.67,
    x2: 66.68,
    y2: 26.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.91,
    y1: 37.85,
    x2: 66.68,
    y2: 37.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.91,
    y1: 49.03,
    x2: 66.68,
    y2: 49.03
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.32,
    y1: 26.67,
    x2: 14.09,
    y2: 26.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.32,
    y1: 37.85,
    x2: 14.09,
    y2: 37.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.32,
    y1: 49.03,
    x2: 14.09,
    y2: 49.03
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 49.02,
    y1: 60.97,
    x2: 49.02,
    y2: 66.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.84,
    y1: 60.97,
    x2: 37.84,
    y2: 66.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.66,
    y1: 60.97,
    x2: 26.66,
    y2: 66.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomations);
export default __webpack_public_path__ + "static/media/__Automations.ad58534cf7044f52daca8e95b90651e8.svg";
export { ForwardRef as ReactComponent };